export default __webpack_public_path__ + "static/0053-56452dde00518ecf1fabefa3db4946b9.png";